import React from 'react'
import { Route } from 'react-router-dom'
import PrivateRoute from '../Services/PrivateRouter'
import MainSettings from '../Views/Main/MainSettings'
import ProductSettings from '../Views/Web/Settings/Products'
import { CompanyInfo } from '../Views/Web/Settings/CompanyInfo'
import MainMarketingSettings from '../Views/Web/Settings/Marketing/MainMarketing'
import MainProcurementSettings from '../Views/Web/Settings/Procurement/MainProcurement'
import MainSalesSettings from '../Views/Web/Settings/Sales/MainSales'
import MainPaymentsSettings from '../Views/Web/Settings/Payments/MainPayments'
import MainTasksSettings from '../Views/Web/Settings/Tasks/MainTasks'
import MainStoreSettings from '../Views/Web/Settings/Store/MainStore'
import MainShippingSettings from '../Views/Web/Settings/Shipping/MainShipping'
import MainMaintenanceSettings from '../Views/Web/Settings/Maintenance/MainMaintenance'
import MainUserRoleSettings from '../Views/Web/Settings/UserRole/MainUserRole'
import MainJobRoleSettings from '../Views/Web/Settings/JobRole/MainJobRole'
import { CreateUser, EditUser, MainUserSettings, MainUserSettingsIndex, ViewUser } from '../Views/Web/Settings/User'
import MainNotification from '../Views/Web/Settings/Notification/MainNotification'
import ReffrenceSettings from '../Views/Web/Settings/Reffrence'
import { CreateRole, EditRole, MainRole, MainRolesSettings, ViewRole } from '../Views/Web/Settings/Role'
import MainCurrencyAndVat from '../Views/Web/Settings/CurrencyAndVat/MainCurrencyAndVat'
import EditCompanyInfo from '../Views/Web/Settings/CompanyInfo/EditCompanyInfo'
// import SealAndSignature from '../Views/Web/Settings/SealAndSignature'
import MainSealPage from '../Views/Web/Settings/SealAndSignature/MainSealPage'
import MainStatusPermission from '../Views/Web/Settings/StatusPermission/MainStatusPermission'
import { Wrapper } from '../Components/Utils/roles'
import MainEmailServerdetails from '../Views/Web/Settings/EmailServerDetails/MainEmailServerdetails'
import MainTemplate from '../Views/Web/Settings/Template/MainTemplate'
import MainPdfTemplate from '../Views/Web/Settings/PDFTemplate/MainPdfTemplate'
import MainNotes from '../Views/Web/Settings/Notes/MainNotes'
import ApprovalStatusMain from '../Views/Web/Settings/ApprovalStatus.jsx/ApprovalStatusMain'
import MainProjectSett from '../Views/Web/Settings/Project/MainProject'
import MainDiary from '../Views/Web/Settings/My Diary/MainDiary'
import MainDiaryIndex from '../Views/Web/Settings/My Diary/MainDiary'
import NewApprovalIndex from '../Views/Web/Settings/NewApproval/Index'
import MainContractSettings from '../Views/Web/Settings/Contacts/MainContract'
import MainHolidaySettings from '../Views/Web/Settings/Holidays/MainHoliday'
import MainBiddingSettings from '../Views/Web/Settings/Bidding/MainBidding'
import MainEmployee from '../Views/Web/Settings/Employee/MainEmployee'
import IndexHoliday from '../Views/Web/Settings/Holidays/Index'

function SettingsRoutes() {
  return (
    <Route path="/settings/:officeId" element={
        <PrivateRoute>
          <MainSettings/>
        </PrivateRoute>
      }>
        <Route index element={ <Wrapper accessKey={"company_info_view"}  Component={CompanyInfo} />} />
        <Route path='company/edit' element={ <Wrapper accessKey={"company_info_edit"}  Component={EditCompanyInfo} /> } />
        <Route path='products' element={ <Wrapper accessKey={"product_view"}  Component={ProductSettings} />}/>
        <Route path='marketing' element={ <Wrapper accessKey={"marketing_view"}  Component={MainMarketingSettings} /> }/>
        <Route path='procurement' element={ <Wrapper accessKey={"procurement_view"}  Component={MainProcurementSettings} /> }/>
        {/* <Route path='project' element={ <Wrapper accessKey={"project_view"}  Component={MainProjectSettings} /> }/> */}
        <Route path='project' element={ <Wrapper accessKey={"project_view"}  Component={MainProjectSett} /> }/>
        <Route path='my-diary' element={ <Wrapper accessKey={"my_diary_view"}  Component={MainDiary} /> }/>
        <Route path='bidding' element={ <Wrapper accessKey={"bids_view"}  Component={MainBiddingSettings} />}/>
        <Route path='employee' element={ <Wrapper accessKey={"employees_view"}  Component={MainEmployee} />}/>

        <Route path='sales' element={ <Wrapper accessKey={"sales_view"}  Component={MainSalesSettings} />}/>
        <Route path='payments' element={ <Wrapper accessKey={"payment_view"}  Component={MainPaymentsSettings} /> }/>
        <Route path='tasks' element={ <Wrapper accessKey={"task_settings_view"}  Component={MainTasksSettings} />}/>
        <Route path='store' element={ <Wrapper accessKey={"store_view"}  Component={MainStoreSettings} /> }/>
        <Route path='shipping' element={ <Wrapper accessKey={"shipping_view"}  Component={MainShippingSettings} /> }/>
        <Route path='maintenance' element={ <Wrapper accessKey={"maintenance_view"}  Component={MainMaintenanceSettings} />}/>
        <Route path='maintenance' element={ <Wrapper accessKey={"maintenance_view"}  Component={MainMaintenanceSettings} />}/>
        <Route path='contract' element={ <Wrapper accessKey={"sub_contractor_view"}  Component={MainContractSettings} />}/>

        <Route path='user' element={ <MainUserSettings/>}>
          <Route index element={ <Wrapper accessKey={"user_view"}  Component={MainUserSettingsIndex} /> }/>
          <Route path='create' element={ <Wrapper accessKey={"user_create"}  Component={CreateUser} />} />
          <Route path='edit/:editUserId' element={ <Wrapper accessKey={"user_edit"}  Component={EditUser} />} />
          <Route path='view/:viewUserId' element={ <Wrapper accessKey={"user_view"}  Component={ViewUser} />} />
        </Route>
        <Route path='currency-vat' element={ <Wrapper accessKey={true}  Component={MainCurrencyAndVat} />}/>
        <Route path='emailserverdetails' element={ <Wrapper accessKey={true}  Component={MainEmailServerdetails} />}/>
        <Route path='emailserverdetails' element={ <Wrapper accessKey={true}  Component={MainEmailServerdetails} />}/>
        <Route path='emailserverdetails' element={ <Wrapper accessKey={true}  Component={MainEmailServerdetails} />}/>
        <Route path='template' element={ <Wrapper accessKey={true}  Component={MainTemplate} />}/>
        <Route path='pdfTemplate' element={ <Wrapper accessKey={true}  Component={MainPdfTemplate} />}/>
        <Route path='notes' element={ <Wrapper accessKey={true}  Component={MainNotes} />}/>



        <Route path='role' element={<MainRole/>}>
          <Route index element={ <Wrapper accessKey={"role_view"}  Component={MainRolesSettings} /> } />
          <Route path='create' element={ <Wrapper accessKey={"role_create"}  Component={CreateRole} /> } />
          <Route path='edit/:editRoleId' element={ <Wrapper accessKey={"role_edit"}  Component={EditRole} /> } />
          <Route path='view/:viewRoleId' element={ <Wrapper accessKey={"role_view"}  Component={ViewRole} /> } />
        </Route>
        <Route path='user-role' element={ <Wrapper accessKey={"user_role_view"}  Component={MainUserRoleSettings} /> }/>
        <Route path='user-holiday' element={ <Wrapper accessKey={"user_holiday_view"}  Component={IndexHoliday} /> }/>
        <Route path='job-role' element={ <Wrapper accessKey={true}  Component={MainJobRoleSettings} /> }/>
        <Route path='sealandsignature' element={ <Wrapper accessKey={true}  Component={MainSealPage} /> }/>
        <Route path='statuspermission' element={ <Wrapper accessKey={true}  Component={MainStatusPermission} />}/>
        <Route path='approval-status' element={ <Wrapper accessKey={true}  Component={ApprovalStatusMain} />}/>
        <Route path='newApproval' element={ <Wrapper accessKey={true}  Component={NewApprovalIndex} />}/>

        <Route path='notifications' element={ <Wrapper accessKey={"notification_view"}  Component={MainNotification} /> }/>
        <Route path='reffrence' element={ <Wrapper accessKey={"reference_view"}  Component={ReffrenceSettings} /> }/>
      </Route>
  )
}

export default SettingsRoutes